import { TbSearch } from 'react-icons/tb';
import styled from 'styled-components';

const SearchInput = ({ onChange, value }) => {
  return (
    <SearchWrapper>
      <TbSearch color="#ADB5BD" fontSize="16px" />
      <input
        autoComplete="off"
        placeholder="Search"
        value={value}
        onChange={e => onChange(e.target.value)}
      />
    </SearchWrapper>
  );
};

export default SearchInput;

export const SearchWrapper = styled.div`
  width: 100%;
  position: relative;
  svg {
    position: absolute;
    top: 10px;
    left: 12px;
  }
  input {
    border-radius: 4px;
    padding: 8px 12px 8px 35px;
    border: 1px solid #ced4da;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    outline: none;
    &::placeholder {
      color: #adb5bd;
    }
  }
`;
